import { Card, CardContent } from "@/components/ui/card";
import { Star, Clock, Briefcase, CheckCircle2 } from "lucide-react";

interface SubScorecardProps {
  avgRating: number;
  totalJobs: number;
  completedJobs: number;
  onTimePct: number;
}

export function SubScorecard({
  avgRating,
  totalJobs,
  completedJobs,
  onTimePct,
}: SubScorecardProps) {
  return (
    <Card>
      <CardContent className="p-4">
        <h4 className="text-xs font-semibold text-muted-foreground mb-3">
          PERFORMANCE SCORECARD
        </h4>
        <div className="grid grid-cols-4 gap-3">
          <div className="text-center">
            <div className="flex items-center justify-center gap-1 mb-1">
              <Star
                className="w-4 h-4"
                style={{ color: avgRating >= 4 ? "#d97706" : "#9ca3af" }}
              />
            </div>
            <p className="text-xl font-bold tabular-nums">
              {avgRating > 0 ? avgRating.toFixed(1) : "—"}
            </p>
            <p className="text-xs text-muted-foreground">Rating</p>
          </div>
          <div className="text-center">
            <div className="flex items-center justify-center gap-1 mb-1">
              <Briefcase className="w-4 h-4 text-blue-500" />
            </div>
            <p className="text-xl font-bold tabular-nums">{totalJobs}</p>
            <p className="text-xs text-muted-foreground">Assigned</p>
          </div>
          <div className="text-center">
            <div className="flex items-center justify-center gap-1 mb-1">
              <CheckCircle2 className="w-4 h-4 text-green-500" />
            </div>
            <p className="text-xl font-bold tabular-nums">{completedJobs}</p>
            <p className="text-xs text-muted-foreground">Completed</p>
          </div>
          <div className="text-center">
            <div className="flex items-center justify-center gap-1 mb-1">
              <Clock className="w-4 h-4 text-purple-500" />
            </div>
            <p className="text-xl font-bold tabular-nums">
              {onTimePct > 0 ? `${onTimePct.toFixed(0)}%` : "—"}
            </p>
            <p className="text-xs text-muted-foreground">On Time</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
